<template>
  <div class="order-detail-content">
    <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">
        <div class="color-black bold">
          订单审核状态：{{ orderDetail.orderInfo.status_name }}
        </div>
        <div
          v-if="orderDetail.orderInfo.extra.fail_message"
          class="font-size14"
        >
          失败原因：{{ orderDetail.orderInfo.extra.fail_message }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span class="order-detail-student-name">学员姓名： {{ orderDetail.orderInfo.nickname }}</span>
          <span>就读小学：{{ orderDetail.orderInfo.school_name }}</span>
          <span>就读年级：{{ orderDetail.orderInfo.grade_name }}</span>
          <span>渠道来源：{{ orderDetail.orderInfo.channel_name + '--' + orderDetail.orderInfo.channel_sub_name }}</span>
          <span>家长电话：{{ orderDetail.orderInfo.phone }}</span>

        </div>
        <div class="order-detail-people-name">
          <span>订单创建人：{{ orderDetail.orderInfo.lead_create_name }}</span>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        套餐信息
      </div>
      <div class="order-detail-package">
        <div>套餐名称：{{ orderDetail.orderInfo.item_title }}</div>
        <div>课时信息：</div>
        <el-table :data="orderDetail.item_info">
          <el-table-column prop="summary" label="扣费方式" />
          <el-table-column prop="days" label="课时(天)" />
        </el-table>
      </div>

    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        签约信息
      </div>
      <div class="order-detail-package">
        <div>签约单号：{{ orderDetail.orderInfo.order_id }}</div>
        <div>订单金额：¥{{ orderDetail.orderInfo.contract_amount / 100 }}</div>
        <div v-if="orderDetail.orderInfo.deduction_amount != 0">
          余额抵扣：¥{{ orderDetail.orderInfo.deduction_amount / 100 }}
        </div>
        <div class="color-danger">
          实际支付：¥{{ orderDetail.orderInfo.actual_amount / 100 }}
        </div>
        <div v-if="orderDetail.orderInfo.payment">
          支付方式：{{ orderDetail.orderInfo.payment }}
        </div>
        <div v-if="orderDetail.orderInfo.create_time">
          支付时间：{{ orderDetail.orderInfo.success_time }}
        </div>
        <div v-if="orderDetail.orderInfo.payment">
          备注信息：{{ orderDetail.orderInfo.remark }}
        </div>
        <div v-if="orderDetail.orderInfo.remark">
          财务单号：{{ orderDetail.orderInfo.out_trade_no }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        责任人信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>提交人：{{ orderDetail.orderInfo.editor_name }}</span>
          <span>班主任：{{ orderDetail.orderInfo.teacher_name }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'OrderSigningInfo',

  props: {
    orderDetail: Object
  },
  data() {
    return {
      success_remark: '',
      fail_remark: '',
      audit_status: ''
    }
  },
  methods: {
    auditSuccess() {
      if (!this.success_remark) {
        this.$message({
          type: 'info',
          message: '请输入财务流水单号'
        })
        return
      }
      const obj = {
        order_id: this.orderDetail.orderInfo.order_id,
        remark: this.success_remark,
        audit_status: 'success'
      }
      this.$http.auditOrder(obj).then(() => {
        this.$emit('updateOrderList')
      })
    },
    auditFail() {
      if (!this.fail_remark) {
        this.$message({
          type: 'info',
          message: '请填写审核失败原因'
        })
        return
      }
      const obj = {
        order_id: this.orderDetail.orderInfo.order_id,
        remark: this.fail_remark,
        audit_status: 'fail'
      }
      this.$http.auditOrder(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-detail-content {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .special-table {
    width: 100%;
    margin: 30px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
</style>
